import { useAuth0 } from '@auth0/auth0-react';
import useSWRMutation from 'swr/mutation';
import http from '@/Utils/HTTP/NewHttpUtils';

export enum SearchAutocompleteType {
    CompanyName = 'CompanyName',
    JobTitle = 'JobTitle',
}

export interface SearchAutocompleteResponse {
    options: string[];
}

const DefaultSearchAutocompleteResponse: SearchAutocompleteResponse = {
    options: [],
};

export interface SearchAutocompleteRequest {
    query: string;
    type: SearchAutocompleteType;
}

const useSearchAutocompleteOptions = () => {
    const { getAccessTokenSilently } = useAuth0();

    return useSWRMutation(
        'profiles/search-autocomplete',
        async (path: string, { arg }: { arg: SearchAutocompleteRequest }) => {
            if (arg.query.length < 2) {
                return DefaultSearchAutocompleteResponse;
            }

            const response = await http.post<SearchAutocompleteResponse>({
                path,
                accessToken: await getAccessTokenSilently(),
                body: arg,
            });

            return response || DefaultSearchAutocompleteResponse;
        },
    );
};

export default useSearchAutocompleteOptions;
